<template>
  <div
    class="box-presenting-right items-center pl-1.5 pr-1.5 rounded-xl"
    v-tooltip="`${editorName} can host ${limit} participants (<span class='capitalize'>${plan.group}</span>)`"
  >
    <img src="@/assets/images/elements/users-present.svg" alt="" class="inline">
    <span class="relative top-0.25 ml-0.5">{{ planLimit | formatNumber }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Pricing from '@/pricing'

export default {
  props: {
    owner: {
      type: Object,
      default: () => {},
    },
    editor: {
      type: Object,
      default: () => {},
    },
    editorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      plan: {},
      limit: 0,
    }
  },
  computed: {
    ...mapGetters(['planLimit']),

  },
  created() {
    const ownerPlan = Pricing.getPlanByType(this.owner.plan)
    const editorPlan = Pricing.getPlanByType(this.editor.plan || 'free')
    if (ownerPlan.limit > editorPlan.limit) {
      this.plan = ownerPlan
    } else {
      this.plan = editorPlan
    }
    this.limit = this.plan.limit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
}
</script>

<style lang="scss" scoped>
.box-presenting-right {
  background-color: #F0EBFF;
  font-size: 10px;
  position: relative;
  top: -2px;
  color: #4F40A8;
  display: inline-block !important;
}
</style>
